import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSeoUrlsSucceed, EGetSeoUrlsActionType } from './types';
import { ISeoUrlsNew } from '../../../types/seo_urls';

export const getSeoUrlsSucceed: (data: ISeoUrlsNew) => TGetSeoUrlsSucceed = actionGenerator<
  EGetSeoUrlsActionType.Succeed,
  ISeoUrlsNew
>(EGetSeoUrlsActionType.Succeed);
